import Component from 'D:/HBuilderProjects/园博园/uni_modules/uni-icons/components/uni-icons/uni-icons.vue'
wx.createComponent(Component)